<template>
  <div class="fllow_box" v-show="fllowList.length != 0">
    <div class="title_box">
      <i class="icon"></i>
      <span>大神玩家推荐</span>
    </div>
    <div class="fllow_line" v-for="(item, index) in fllowList" :key="index">
      <div class="avatar" @click="goUserPage(item.id)">
        <img :src="item.avatar" alt="" />
        <i :class="item.isauth ? 'memberAuthInfoFlag' : ''"></i>
      </div>
      <span class="name">{{ item.name }}</span>
      <div
        :class="`fllow_btn ${item.isFollow ? 'fllow_ed_btn' : ''}`"
        @click="focusClick(item, index)"
      >
        {{ item.isFollow ? '已关注' : '关注' }}
      </div>
    </div>
  </div>
</template>

<script>
import get from '@/api/get';
export default {
  components: {},
  data() {
    return {
      fllowList: [
        // {
        //   id: '',
        //   name: '等哈就好的',
        //   avatar: '//snspic.zlongame.com/sns/manage/avatar/1672196856443.png',
        //   isFollow: false,
        //   isauth: false
        // }
      ]
    };
  },
  computed: {},
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    }
  },
  methods: {
    //关注&&取消关注
    focusClick(item, index) {
      get.follow(item.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          // this.$set(
          //   this.fllowList[index],
          //   'isFollow',
          //   !this.fllowList[index].isFollow
          // );
          this.fllowList[index].isFollow = !this.fllowList[index].isFollow;
        } else {
          this.errorMessage(data);
        }
      });
    },
    //去用户主页
    goUserPage(id) {
      if (this.$store.state.loginStatus == 1) {
        this.$router.push({
          name: 'otherHome',
          query: { id: id, newpage: true, pageNo: 1 }
        });
      } else {
        this.$store.commit('changeLoginShow', true);
      }
    },
    getUsers() {
      get.getGlGameintroUsers().then((res) => {
        this.fllowList = res.data.data.map((item) => {
          return {
            id: item.id,
            name: item.nick_name,
            avatar: item.avatar,
            isFollow: item.isFollow == 0 ? false : true,
            isauth: item.auth_info == '钢岚大神' ? true : false
          };
        });
      });
    }
  },
  async created() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.getUsers();
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.gl .side_box .fllow_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
  border-radius: 0.2rem;
  padding: 0 0.22rem;
  padding-top: 0.2rem;
  box-sizing: border-box;
  .title_box {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    .icon {
      width: 0.25rem;
      height: 0.28rem;
      background: url(~@/assets/img/gl/icon10_homepage.png);
      background-size: 100% 100%;
      margin-right: 0.15rem;
    }
    span {
      font-weight: bold;
      color: #2b2b2b;
      font-size: 0.24rem;
    }
  }
  .fllow_line {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    .avatar {
      flex-shrink: 0;
      width: 0.55rem;
      height: 0.55rem;
      position: relative;
      margin-right: 0.16rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .office_icon {
        width: 0.18rem;
        height: 0.18rem;
        background: url(~@/assets/img/icon9.png);
        background-size: 100% 100%;
        position: absolute;
        bottom: -0.01rem;
        right: -0.01rem;
      }
      .memberAuthInfoFlag {
        width: 0.18rem;
        height: 0.18rem;
        background: url('~@/assets/img/icon4.png') no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        bottom: -0.01rem;
        right: -0.01rem;
      }
    }
    .name {
      width: 100%;
      font-weight: 500;
      color: #2b2b2b;
      font-size: 0.22rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .fllow_btn {
      flex-shrink: 0;
      width: 0.89rem;
      height: 0.4rem;
      border: 0.01rem solid #2b2b2b;
      color: #2b2b2b;
      font-weight: bold;
      font-size: 0.19rem;
      text-align: center;
      line-height: 0.4rem;
      cursor: pointer;
    }
    .fllow_ed_btn {
      border: 1px solid #808492;
      color: #808492;
    }
  }
}
</style>